module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"see_all":"查看全部评价"}}')
  delete Component.options._Ctor
}
